import React from 'react';
import {observer} from 'mobx-react';
import {DefaultRoute, withRouter} from 'react-router-dom'
import GroupOfField from "../../components/layout/GroupOfField";
import {withApollo} from "react-apollo";
import PageTitle from "../../components/PageTitle";
import TabsComponent from "../../components/fields/TabsComponent";
import TabsData from "../../layout/TabsData";
import PageTitleRightModal from "../../components/PageTitleRightModal";
import PropsUtil from "../../util/PropsUtil";
import InfoBlock from "../../components/InfoBlock";
import util from '../../util/Util'
import BaseForm from "../base/BaseForm";
import HistoryComponent from "../../components/HistoryComponent";
import OrderModel from "../../models/OrderModel";
import withTranslate from "../../translator/withTranslate";
import appState from "../../state/AppState";

@observer
class OrderHistory extends BaseForm {
    constructor(props) {
        super(props);
        this.tabsData = new TabsData();
        this.nameMainType = "order";
        this.initializeGraphData(this.nameMainType);
    }

    getModelQuery() {
        return new OrderModel();
    }

    async componentDidMountImpl() {
        //TODO EBB
        // await super.componentDidMountImpl();
        // this.log("componentDidMount");
        // await appState.clientCacheState.loadClientCache();
        // await appState.assetState.getAssets();
        // await appState.userCacheState.loadUserCache();
        //
        // await appState.typifiedState.loadStatus();
        // await appState.typifiedState.loadPriority();
        // await appState.typifiedState.loadSymptom();
        // await appState.typifiedState.loadWorkOrderType();
        // await appState.typifiedState.loadSubTypeWorkOrder();
        //
        // await appState.typifiedState.loadAssetType();
        // await appState.typifiedState.loadAssetSubtype();
        // await appState.typifiedState.loadManufacturer();
        //
        // appState.typifiedState.arrayLoadAssetType();
        // appState.typifiedState.arrayLoadAssetSubType();
        // appState.typifiedState.arrayLoadManufacturer();


    }

    render() {
        console.log("OrderHistory render =>");
        this.propsUtil = new PropsUtil(this.props);
        let modalClasses = util.getModalClasses();
        const {t, i18n} = this.props;
        let order = this.graphDataMainType;

        return (
            <div className={this.props.fromRightModal ? modalClasses.push : ""}>
                <InfoBlock componentObject={this}>

                    {this.props.fromRightModal ?

                        <div className={modalClasses.head}>
                            <PageTitleRightModal
                                title={"Pedido"}
                                subtitle={order.code || t("Histórico")}
                                mode={"view"}
                                onCloseModal={() => this.onCloseModal()}
                            />
                            <TabsComponent
                                id={this.getFormId()}
                                tabs={this.tabsData.getDataOrder()}
                                active={"Histórico"}
                                fromRightModal={this.props.fromRightModal}
                            />
                        </div>
                        :
                        <PageTitle
                            title={t("Pedido")}
                            subtitle={order.code || t("Histórico")}
                        />
                    }

                    <div className="card mb-3">
                        {!this.props.fromRightModal &&
                        <TabsComponent
                            id={this.getFormId()}
                            tabs={this.tabsData.getDataOrder()}
                            active={"Histórico"}
                        />
                        }
                        <div className="card-body">
                            <HistoryComponent
                                id={this.getFormId()}
                                modelo={this.getModelQuery()}
                            />


                        </div>

                    </div>
                </InfoBlock>
            </div>
        );
    }

}

export default withRouter(withApollo(withTranslate(OrderHistory)));
